import {
  Sun,
  Moon,
  CloudSun,
  CloudMoon,
  Cloud,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudSnow,
  CloudLightning,
  CloudHail,
  Thermometer,
} from 'lucide-react';
import type { WeatherSnapshot } from './weather-adapter';
import { weatherSymbol } from './weather-symbol';

const icons = {
  sun: Sun,
  moon: Moon,
  'cloud-sun': CloudSun,
  'cloud-moon': CloudMoon,
  cloud: Cloud,
  fog: CloudFog,
  drizzle: CloudDrizzle,
  rain: CloudRain,
  snow: CloudSnow,
  thunder: CloudLightning,
  hail: CloudHail,
  unknown: Thermometer,
};
export function WeatherIcon({
  weather,
  size = 23,
}: {
  weather: WeatherSnapshot | null;
  size?: number;
}) {
  const symbol = weatherSymbol(weather),
    Icon = icons[symbol];
  return <Icon size={size} aria-hidden="true" data-weather-symbol={symbol} />;
}
